import App from '@app/app.js';
import template from './select-photo-carousel.html';
import './select-photo-carousel.scss';

class SelectPhotoCarouselController {
  constructor($scope) {
    this.$scope = $scope;
  }

  $onInit() {}

  onSelect(value, index) {
    this.selected({ value });
    this.selectedIndex = index;
  }
}

SelectPhotoCarouselController.$inject = ['$scope'];
App.component('ltSelectPhotoCarousel', {
  template,
  bindings: {
    photos: '<',
    selectedIndex: '=',
    selected: '&',
    noActiveIndicator: '<'
  },
  transclude: true,
  controller: SelectPhotoCarouselController,
  controllerAs: 'select'
});
